import { FormControl, ValidationErrors } from "@angular/forms";

export function emailValidator(control: FormControl): ValidationErrors {
	return !control.value ||
	  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$/.test(control.value)
	  ? null
	  : { email: true };
  }


  export function emailValidationMessage(err, field) {
	return `"${field.formControl.value}" is not valid email address`;
  }
  
  